/**
 * PetCubes Malaysia Geo-Redirect
 * Detects Malaysian visitors on petcubes.com and prompts them
 * to visit the localized petcubes.my site.
 *
 * Usage: Add this script to your site's <head> or before </body>
 *   <script src="petcubes-my-redirect.js"></script>
 *
 * Or paste the contents inline in a <script> tag.
 */

(function () {
  "use strict";

  const CONFIG = {
    targetCountry: "MY",
    redirectUrl: "https://www.petcubes.my",
    currentSite: "petcubes.com",
    storageKey: "petcubes_redirect_dismissed",
    dismissDays: 30, // Don't show again for 30 days after dismissal
  };

  // --- Helpers ---

  function getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  }

  function hasDismissed() {
    return getCookie(CONFIG.storageKey) === "1";
  }

  function setDismissed() {
    setCookie(CONFIG.storageKey, "1", CONFIG.dismissDays);
  }

  // --- Popup UI ---

  function injectStyles() {
    if (document.getElementById("pc-redirect-styles")) return;
    const style = document.createElement("style");
    style.id = "pc-redirect-styles";
    style.textContent = `
      #pc-redirect-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.55);
        backdrop-filter: blur(3px);
        -webkit-backdrop-filter: blur(3px);
        z-index: 999999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;
        animation: pc-fade-in 0.25s ease;
      }
      @keyframes pc-fade-in {
        from { opacity: 0; }
        to   { opacity: 1; }
      }
      #pc-redirect-box {
        background: #ffffff;
        border-radius: 16px;
        box-shadow: 0 24px 60px rgba(0,0,0,0.22);
        max-width: 420px;
        width: 100%;
        padding: 36px 32px 28px;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        position: relative;
        animation: pc-slide-up 0.28s cubic-bezier(0.34,1.56,0.64,1);
      }
      @keyframes pc-slide-up {
        from { transform: translateY(24px); opacity: 0; }
        to   { transform: translateY(0);   opacity: 1; }
      }
      #pc-redirect-close {
        position: absolute;
        top: 14px;
        right: 16px;
        background: none;
        border: none;
        font-size: 22px;
        line-height: 1;
        cursor: pointer;
        color: #999;
        padding: 4px 6px;
        border-radius: 6px;
        transition: background 0.15s, color 0.15s;
      }
      #pc-redirect-close:hover { background: #f2f2f2; color: #333; }
      #pc-redirect-flag {
        font-size: 38px;
        margin-bottom: 10px;
        text-align:center;
        display: block;
      }
      #pc-redirect-box h2 {
        margin: 0 0 8px;
        font-size: 20px;
        font-weight: 700;
        color: #1a1a1a;
        line-height: 1.3;
      }
      #pc-redirect-box p {
        margin: 0 0 24px;
        font-size: 14.5px;
        color: #555;
        line-height: 1.6;
      }
      #pc-redirect-box p strong {
        color: #e85d14;
      }
      .pc-btn-group {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
      }
      .pc-btn {
        flex: 1;
        min-width: 120px;
        padding: 12px 18px;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        border: none;
        transition: transform 0.12s, box-shadow 0.12s, background 0.15s;
        text-align: center;
      }
      .pc-btn:active { transform: scale(0.97); }
      #pc-redirect-go {
        background: #e85d14;
        color: #fff;
        box-shadow: 0 4px 14px rgba(232,93,20,0.35);
      }
      #pc-redirect-go:hover {
        background: #cf4d08;
        box-shadow: 0 6px 18px rgba(232,93,20,0.45);
      }
      #pc-redirect-stay {
        background: #f2f2f2;
        color: #444;
      }
      #pc-redirect-stay:hover { background: #e6e6e6; }
      #pc-redirect-note {
        margin-top: 16px !important;
        font-size: 12px !important;
        color: #aaa !important;
        text-align: center;
        margin-bottom: 0 !important;
      }
      @media (max-width: 480px) {
        #pc-redirect-box { padding: 28px 20px 22px; }
        .pc-btn-group { flex-direction: column; }
      }
    `;
    document.head.appendChild(style);
  }

  function showPopup() {
    injectStyles();

    const overlay = document.createElement("div");
    overlay.id = "pc-redirect-overlay";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-labelledby", "pc-redirect-title");

    overlay.innerHTML = `
      <div id="pc-redirect-box">
        <button id="pc-redirect-close" aria-label="Close">&times;</button>
        <span id="pc-redirect-flag"><img src="https://petcubes.com/cdn/shop/files/PetCubes_LOGO.png?v=1696652846&width=1200" width="64" height="64"></span>
        <h2 id="pc-redirect-title">You're visiting from Malaysia!</h2>
        <p>
          We have a dedicated Malaysian store at
          <strong>petcubes.my</strong> with local pricing,
          Bahasa Malaysia support, and faster delivery across Malaysia.
        </p>
        <div class="pc-btn-group">
          <button class="pc-btn" id="pc-redirect-go">Go to petcubes.my</button>
          <button class="pc-btn" id="pc-redirect-stay">Stay on .com</button>
        </div>
        <p id="pc-redirect-note">We won't ask again for 30 days.</p>
      </div>
    `;

    document.body.appendChild(overlay);

    // Trap focus inside dialog
    const focusable = overlay.querySelectorAll("button");
    focusable[0].focus();

    function closePopup() {
      overlay.style.animation = "none";
      overlay.style.opacity = "0";
      overlay.style.transition = "opacity 0.2s";
      setTimeout(() => overlay.remove(), 200);
    }

    document.getElementById("pc-redirect-go").addEventListener("click", function () {
      window.location.href = CONFIG.redirectUrl;
    });

    document.getElementById("pc-redirect-stay").addEventListener("click", function () {
      setDismissed();
      closePopup();
    });

    document.getElementById("pc-redirect-close").addEventListener("click", function () {
      setDismissed();
      closePopup();
    });

    // Close on overlay click (outside box)
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) {
        setDismissed();
        closePopup();
      }
    });

    // Close on Escape
    document.addEventListener("keydown", function onKey(e) {
      if (e.key === "Escape") {
        setDismissed();
        closePopup();
        document.removeEventListener("keydown", onKey);
      }
    });
  }

  // --- Geo Detection ---

  /**
   * Strategy 1: ipapi.co (free, no API key needed, 1000 req/day)
   * Strategy 2: ip-api.com (free, no HTTPS on free tier — used as fallback via HTTP)
   * Strategy 3: cloudflare headers (if site is behind Cloudflare, cf-ipcountry header)
   *
   * We use ipapi.co as primary. Both are free and require no setup.
   */

  function checkCountryAndShow(countryCode) {
    if (countryCode && countryCode.toUpperCase() === CONFIG.targetCountry) {
      showPopup();
    }
  }

  function detectViaCloudflareHeader() {
    // Only works if the page itself exposes CF-IPCountry via a meta tag or SSR.
    // Common pattern: <meta name="cf-ipcountry" content="MY">
    const meta = document.querySelector('meta[name="cf-ipcountry"]');
    if (meta) {
      return meta.getAttribute("content");
    }
    return null;
  }

  function detectViaIpApi(callback) {
    // ip-api.com: free, no key, HTTP only (switch to HTTPS on Pro)
    const script = document.createElement("script");
    const callbackName = "__pc_ipapi_cb_" + Date.now();
    window[callbackName] = function (data) {
      delete window[callbackName];
      document.head.removeChild(script);
      callback(data && data.countryCode ? data.countryCode : null);
    };
    script.src = "http://ip-api.com/json/?fields=countryCode&callback=" + callbackName;
    script.onerror = function () {
      delete window[callbackName];
      try { document.head.removeChild(script); } catch (_) {}
      callback(null);
    };
    document.head.appendChild(script);
  }

  function detectViaIpApiCo(callback) {
    // ipapi.co: free up to 1,000/day, HTTPS, CORS-enabled JSON endpoint
    fetch("https://ipapi.co/json/", { cache: "no-store" })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        callback(data && data.country_code ? data.country_code : null);
      })
      .catch(function () { callback(null); });
  }

  // --- Entry Point ---

  function init() {
    // Don't show if already dismissed
    if (hasDismissed()) return;

    // Don't run on petcubes.my itself
    if (window.location.hostname.indexOf("petcubes.my") !== -1) return;

    // 1. Try Cloudflare header first (instant, no network request)
    const cfCountry = detectViaCloudflareHeader();
    if (cfCountry) {
      checkCountryAndShow(cfCountry);
      return;
    }

    // 2. Try ipapi.co (HTTPS, CORS-enabled)
    detectViaIpApiCo(function (country) {
      if (country) {
        checkCountryAndShow(country);
      } else {
        // 3. Fallback to ip-api.com (JSONP, HTTP)
        detectViaIpApi(function (country2) {
          checkCountryAndShow(country2);
        });
      }
    });
  }

  // Run after DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();